import styled from 'styled-components'

interface IStyleProps {
  investCard?: boolean
  changeOpacity?: boolean
}

const CardContainer = styled.div<IStyleProps>`
  position: relative;
  padding: 8px;

  opacity: ${(props: IStyleProps) => (props.changeOpacity ? 0.5 : 1)};
  cursor: grab;
  transition: opacity 0.3s ease;
  height: ${(props: IStyleProps) => {
    if (props.investCard) return '335px'
    return '142px'
  }};
`

export { CardContainer }
